import { __ } from "@wordpress/i18n";
import { useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const BotRestrictions = ({handleChange}) => {

    const {
        settingData,
		setSettingData
    } = useMenu();  

    const bots = [
		{'Googlebot' : 'Google Bot',},
		{'Bingbot' : 'Bing Bot',},
		{'YandexBot' : 'Yandex Bot',},
		{'Baiduspider' : 'Baidu Spider',},
		{'DuckDuckBot' : 'DuckDuckGo Bot',},
		{'Yahoo! Slurp' : 'Yahoo Bot',},
		{'AhrefsBot' : 'Ahrefs Bot',},
		{'MJ12bot' : 'Majestic Bot',},
		{'SemrushBot' : 'SEMrush Bot',},
		{'DotBot' : 'Moz DotBot',},
		{'Exabot' : 'Exalead Bot',},
		{'Applebot' : 'Apple Bot',},
		{'Twitterbot' : 'Twitter Bot',},
		{'facebookexternalhit' : 'Facebook Bot',},
		{'LinkedInBot' : 'LinkedIn Bot',},
		{'Pinterestbot' : 'Pinterest Bot',},
		{'Slackbot' : 'Slack Bot',},
		{'Discordbot' : 'Discord Bot',},
		{'SiteAuditBot' : 'SiteAudit Bot',},
		{'Screaming Frog SEO Spider' : 'Screaming Frog Bot',},
		{'postmanruntime' : 'Postman',},
    ];
    const [filteredBots, setFilteredBots] = useState(bots);

    // Calculate bot- columns for the grid - split evenly into 4 columns
    const createBotsColumns = () => {
        if (filteredBots.length === 0) return [[], [], [], []];

        const columnSize = Math.ceil(filteredBots.length / 4);
        return [
            filteredBots.slice(0, columnSize),
            filteredBots.slice(columnSize, columnSize * 2),
            filteredBots.slice(columnSize * 2, columnSize * 3),
            filteredBots.slice(columnSize * 3),
        ];
    };
    const columns = createBotsColumns();  
	const toggleBlocklist = (value) => {
		setSettingData((prev) => {
			const blockedBots =
				prev?.restrictions?.bot_restrictions?.blocked_bots || [];

			const updatedBots = blockedBots.includes(value)
				? blockedBots.filter((bot) => bot !== value) // remove
				: [...blockedBots, value]; // add

			return {
				...prev,
				restrictions: {
					...prev.restrictions,
					bot_restrictions: {
						...prev.restrictions.bot_restrictions,
						blocked_bots: updatedBots,
					},
				},
			};
		});
	}; 
	const blockedBots = settingData?.restrictions?.bot_restrictions?.blocked_bots || [];
	const [activeFilter, setActiveFilter] = useState('all');
	const [filteProcessing, setFilterProcessing] = useState(false);
	const showAllBots = () => {
		setFilterProcessing(true);
		setActiveFilter('all');
		setFilteredBots(bots);
		setFilterProcessing(false);
	};
	const showAllowedBots = () => {
		setFilterProcessing(true);
		setActiveFilter('allowed');
		setFilteredBots(
			bots.filter((bot) => {
				const [code] = Object.keys(bot);
				return !blockedBots.includes(code);
			})
		);
		setFilterProcessing(false);
	};

	const showBlockedBots = () => {
		setFilterProcessing(true);
		setActiveFilter('blocked');
		setFilteredBots(
			bots.filter((bot) => {
				const [code] = Object.keys(bot);
				return blockedBots.includes(code);
			})
		);
		setFilterProcessing(false);
	};
	
	const allChecked = blockedBots.length === bots.length;
	// Toggle all: if all are blocked, uncheck all; otherwise check all
	const toggleAllBots = () => {
		const allCodes = bots.map((c) => Object.keys(c)[0]);
		setSettingData((prev) => ({
			...prev,
			restrictions: {
				...prev.restrictions,
				bot_restrictions: {
				...prev.restrictions.bot_restrictions,
				blocked_bots:
					blockedBots.length === bots.length ? [] : allCodes,
				},
			},
		}));
	};
    return (
        <>
			{/* {console.log(blockedBots)} */}
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Blocked Bots", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select bots from which access will be blocked", "ultimate-security")}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
			<div className="setting-unit pb-lg mb-lg">
				<div className="row">
					<div className="col-lg-5">
						<div className="title-group">
							<h5 className="pl-heading-1 fw-600 text-text">{__("Restrict site access to visitors who aren't logged in or allowed by IP address", "ultimate-security")}</h5>
						</div>
					</div>
					<div className="col-lg-7">
						<div className="row justify-content-between">
							<div className="col-lg-10">
								<div className="title-group d-flex align-items-center ">
									<Hint position="top" content={__("Enable/disable restrictions", "ultimate-security")}/>
									<h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
								</div>
								
							</div>
							
							<div className="col-auto">
								<Switch 
									name="restrictions.bot_restrictions.firewall"
									checked={settingData?.restrictions?.bot_restrictions?.firewall}
									onChange={handleChange} 
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div className="setting-unit">
                {/* {console.log(filteredBots)} */}
                <div className="checkbox-group-table">
                    <div className="checkbox-group-sidebar">
                        <div className="sidebar-header"><span>Group (Total/Granted)</span></div>
                        <div className="quick-filter">
                            <div className="sidebar-menu">
                                <div className="sidebar-dropdown">
                                    <div className={`dropdown-item ${activeFilter == 'all'?'active':''}`}>
										<button disabled={filteProcessing} onClick={showAllBots}>All</button>
									</div>
                                    <div className={`dropdown-item ${activeFilter == 'allowed'?'active':''}`}>
                                        <button disabled={filteProcessing} onClick={showAllowedBots}>Allowed Bots</button>
                                    </div>
                                    <div className={`dropdown-item ${activeFilter == 'blocked'?'active':''}`}>
                                        <button disabled={filteProcessing} onClick={showBlockedBots}>Blocked Bots</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="checkbox-group-content">
                        <div className="content-header">
                            <div className="toggle-option"><span>Block all</span>
                                <div className="position-relative ultimate-security-switcher">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={allChecked}
          									onChange={toggleAllBots}
                                        />
                                        <em data-on="Active" data-off="Inactive"></em>
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="checkbox-group-grid">
                            {columns.map((column, columnIndex) => (
                                <div key={columnIndex} className="checkbox-group-column">
                                    {/* {console.log(column)} */}
                                    {column.map((bot, index) => (
                                    <div key={`${bot}-${index}`} className="checkbox-group-item">
										{/* {console.log(settingData?.restrictions?.bot_restrictions?.blocked_bots)} */}
										{/* {console.log(Object.keys(bot)[0])} */}
                                        <input
                                        type="checkbox"
                                        checked={settingData?.restrictions?.bot_restrictions?.blocked_bots.includes(Object.keys(bot)[0])}
                                        id={Object.keys(bot)[0]}
                                        value={Object.keys(bot)[0]}
                                        onChange={() => toggleBlocklist(Object.keys(bot)[0])}
                                        // disabled={isReadOnly}
                                        />
                                        <label htmlFor={Object.keys(bot)}>
                                        {Object.values(bot)[0]}
                                        </label>
                                    </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(BotRestrictions, 'restrictions.bot_restrictions');